import React from 'react';
import Grid from '@material-ui/core/Grid';
import { TreemapChart } from 'app/components/Charts/treemap';
import { TreemapDataModel } from 'app/components/Charts/treemap/data';
import { DonorsFragmentTable } from 'app/fragments/donors-fragment/common/table';

interface DonorsFragmentLayoutProps {
  showViz: boolean;
  pageParam: string;
  detailBaseFilter: string;
  treemapData: TreemapDataModel;
}

export const DonorsFragmentLayout = (props: DonorsFragmentLayoutProps) => {
  return (
    <Grid
      item
      sm={12}
      md={12}
      lg={12}
      css={`
        @media (max-width: 960px) {
          gap: 20px;
        }
      `}
    >
      {props.showViz ? (
        <TreemapChart
          aria-label="Treemap showing total budget divided by donors."
          label="Donors"
          data={props.treemapData}
          pageParam={props.pageParam}
          detailBaseFilter={props.detailBaseFilter}
        />
      ) : (
        <DonorsFragmentTable
          pageParam={props.pageParam}
          detailBaseFilter={props.detailBaseFilter}
        />
      )}
    </Grid>
  );
};
